import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../RootState";
import { LeadHabiStackRequest } from "./state";
import * as API from "./api";

export const listHabiLeadsStacks = createAsyncThunk<{ list: LeadHabiStackRequest[], total: number }/** RESPONSE TYPE */,
    void,
    {
        state: RootState; //Esto indica a redux-toolkit que este es la interface que define el state
    }
>('habileads/listHabiLeadsStacks', async (_: void, thunkAPI) => {
    const store: RootState = thunkAPI.getState();
    const { token } = store.User;
    return API.listHabiLeadsStacks(token, "1", "20");
});


export const createHabiStackLeads = createAsyncThunk<{ list: LeadHabiStackRequest[], total: number }/** RESPONSE TYPE */,
    number,
    {
        state: RootState; //Esto indica a redux-toolkit que este es la interface que define el state
    }
>('habileads/createHabiStackLeads', async (count: number, thunkAPI) => {
    const store: RootState = thunkAPI.getState();
    const { token } = store.User;
    return API.createHabiStackLeads(token, count);
});
